import { render, staticRenderFns } from "./CourseImportWizard.vue?vue&type=template&id=086fee30&scoped=true"
import script from "./CourseImportWizard.vue?vue&type=script&lang=js"
export * from "./CourseImportWizard.vue?vue&type=script&lang=js"
import style0 from "./CourseImportWizard.vue?vue&type=style&index=0&id=086fee30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086fee30",
  null
  
)

export default component.exports